<div id="bca-choose-extras" class="choose-extras-border nes-p-6">
  <div>
    <div class="nes-flex nes-flex-col nes-gap-10 nes-mb-10">
      <ng-container
        *ngFor="let addon of selectedProduct.addons; trackBy: trackByIdentifier"
      >
        <bca-product-addon
          [addon]="addon"
          [routeLoading]="
            (routeLoading$ | async) &&
            selectedProduct.identifier === ProductIdentifier.Traject
          "
          (selected)="onAddonSelected(addon, $event)"
        >
        </bca-product-addon>
      </ng-container>
    </div>


    <div class="nes-mb-3">
      <div class="nes-mb-3">
        <div class="nes-flex nes-gap-3">
          <h3 class="nes-h4" style="font-size: 16px;">
            {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.TITLE" | translate }}
          </h3>
        </div>
        <p class="services-explainer">
          {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.EXPLAINER" | translate }}
        </p>
      </div>

      <div class="toggle-group">
        <nes-selectable
          #useExtrasButtonTrue
          class="toggle-btn toggle-btn--left"
          [class.toggle-btn--active]="(servicesNotExpanded$ | async)"
          id="useExtrasButtonTrue"
          nes-id="useExtrasButtonTrue"
          [label]="'COMPOSE.CHOOSE_EXTRAS.SERVICES.BUTTON.CONFIRM' | translate"
          name="option-yes"
          [checked]="(servicesNotExpanded$ | async)"
          (nesOnClick)="onServicesToggleClick(false)"
        >
          <div class="nes-flex nes-items-center nes-justify-center nes-h-full toggle-btn-text">
            {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.BUTTON.CONFIRM" | translate }}
          </div>
        </nes-selectable>

        <nes-selectable
          #useExtrasButtonFalse
          class="toggle-btn toggle-btn--right"
          [class.toggle-btn--active]="!(servicesNotExpanded$ | async)"
          id="useExtrasButtonFalse"
          nes-id="useExtrasButtonFalse"
          [label]="'COMPOSE.CHOOSE_EXTRAS.SERVICES.BUTTON.DECLINE' | translate"
          name="option-no"
          [checked]="!(servicesNotExpanded$ | async)"
          (nesOnClick)="onServicesToggleClick(true)"
        >
          <div class="nes-flex nes-items-center nes-justify-center nes-h-full toggle-btn-text">
            {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.BUTTON.DECLINE" | translate }}
          </div>
        </nes-selectable>
      </div>
    </div>

  </div>
</div>

<bca-choose-services-dialog></bca-choose-services-dialog>
